import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import close from './icn_close.svg'
import open from './icn_menu.svg'
import { useWindowSize } from 'usehooks-ts'

// window.dataLayer = window.dataLayer || []
// const trackEvent = (event_label?: string | number) => {
//   if (window.dataLayer)
//     window.dataLayer.push({
//       event_label,
//       ...{
//         event: 'Interactions',
//         event_action: 'click',
//       },
//     })
// }

const test = window.document.title === 'TA-Interaktiv Microfrontend'

declare global {
  interface Window {
    chapters: {
      [key: string]: {
        el: HTMLDivElement
        id: string
        title: string
        short: string
        order: string
      }
    }
  }
}
window.chapters = window.chapters || {}
const testData = [
  { title: 'Titel für Kapitel 1', short: 'Unterschiede?', id: 'a' },
  {
    title: 'Wie lernt ein Algo&shy;rhitmus Test?',
    short: 'Kapitel 2',
    id: 'b',
  },
  { title: 'Titel für Kapitel 3', short: 'Kapitel 3', id: 'c' },
  { title: 'Titel für Kapitel 4', short: 'Kapitel 4', id: 'd' },
]

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  trackEvent,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [isOpen, setOpen] = useState(false)
  const [isVisible, setVisible] = useState(false)
  const [chapterData, setChapterData] = useState<any[] | undefined>(
    test ? testData : undefined
  )
  const [activeChapter, setActiveChapter] = useState<string | undefined>()
  const [isMobile, setMobile] = useState(false)
  const [xPosition, setXposition] = useState<number>(window.innerWidth - 40)
  const { width } = useWindowSize()
  const mobileContainerRef = useRef<HTMLDivElement>()
  // set visual type
  useEffect(() => {
    console.log('width changed')

    if (!width) return
    if (width < 1072) {
      setMobile(true)
      setOpen(false)
    } else {
      setMobile(false)
      setOpen(true)
    }
  }, [width])

  useEffect(() => {
    console.log('width changed')

    let main = document.getElementsByTagName('article')[0]
    if (main) {
      let bb = main.getBoundingClientRect()
      console.log('boundingClientRect: ', bb)
      setXposition(bb.x + bb.width)
    }
  }, [width])

  // set visibility
  useEffect(() => {
    const scrollhandler: (this: Window, ev: Event) => any = (event) => {
      let main = document.getElementsByTagName('article')[0]

      let endOfMain = main.getBoundingClientRect().height - 1000

      let meta: HTMLElement = Array.from(
        main.getElementsByTagName('div')
      ).filter((f) => {
        if (!f.getAttribute('class')) return false
        return f.getAttribute('class').includes('ContentMetaInfo')
      })[0]
      if (!meta) meta = main
      if (
        meta.getBoundingClientRect().y <= -500 &&
        window.scrollY <= endOfMain
      ) {
        setVisible(true)
      } else {
        setVisible(false)
        setOpen(false)
      }
    }
    window.addEventListener('scroll', scrollhandler)

    return () => window.removeEventListener('scroll', scrollhandler)
  }, [])

  // Refresh chapters
  useEffect(() => {
    const handleEvent = (event: CustomEvent) => {
      setChapterData(Object.values(window.chapters) || [])
    }
    window.addEventListener('chapteradded', handleEvent)
    return () => {
      window.removeEventListener('chapteradded', handleEvent)
    }
  }, [])

  useEffect(() => {
    setChapterData(test ? testData : Object.values(window.chapters))
  }, [colorMode, isOpen])

  // Chapter highlight
  useEffect(() => {
    const handleEvent = (event: CustomEvent) => {
      setActiveChapter(event.detail)
    }
    // set chapter data after page rerender
    setChapterData(Object.values(window.chapters) || [])

    window.addEventListener('chapteronscreen', handleEvent)
    return () => {
      window.removeEventListener('chapteronscreen', handleEvent)
    }
  }, [])

  // Chapter dehighlight
  useEffect(() => {
    const handleEvent = (event: CustomEvent) => {
      setActiveChapter(undefined)
    }
    window.addEventListener('chapteroffscreen', handleEvent)
    return () => {
      window.removeEventListener('chapteroffscreen', handleEvent)
    }
  }, [])

  // useEffect(() => {
  //   if (isMobile && isOpen) {
  //     // Scroll int view
  //     let el = mobileContainerRef.current.querySelector('#' + activeChapter)
  //     if (el) {
  //       let width = el.getBoundingClientRect().width
  //       let index =
  //         Array.from(
  //           mobileContainerRef.current.getElementsByClassName('listEntry')
  //         ).findIndex((f) => f.id === activeChapter) || 0

  //       mobileContainerRef.current.scrollLeft = width * index
  //     }
  //   }
  // }, [isOpen])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      {isVisible && isMobile && (
        <MenuContainerMobile className='Menu' isOpen={isOpen}>
          <MenuButton
            className='open'
            onClick={() => {
              isOpen
                ? trackEvent?.('Interactions', {
                    event_action: 'click',
                    event_label: 'chapternav_mob_closed',
                  })
                : trackEvent?.('Interactions', {
                    event_action: 'click',
                    event_label: 'chapternav_mob_opened',
                  })
              setOpen(!isOpen)
            }}
            isOpen={isOpen}
            colorMode={colorMode}
          >
            <img src={open} className='open' />
            <img src={close} className='close' />
          </MenuButton>
          <ListContainer
            className='list'
            ref={mobileContainerRef}
            isOpen={isOpen}
            colorMode={colorMode}
          >
            {chapterData &&
              chapterData
                .sort((a, b) => +a.order - +b.order)
                .map((chapter) => {
                  return (
                    <ListEntry
                      key={chapter.id}
                      id={chapter.id}
                      target={chapter.el}
                      active={chapter.id === activeChapter}
                      long={chapter.title}
                      short={chapter.short}
                      colorMode={colorMode}
                      onSelect={() => {
                        setTimeout(() => {
                          setOpen(false)
                        }, 1000)
                      }}
                      hideShort={properties?.showShortOnMobile && properties?.showShortOnMobile === 'true'}
                      trackEvent={trackEvent}
                    />
                  )
                })}
          </ListContainer>
        </MenuContainerMobile>
      )}
      {isVisible && !isMobile && (
        <ListContainerDesktop
          xpos={xPosition}
          colorMode={colorMode}
          offsetX={+properties?.offsetX}
          className='container'
        >
          {chapterData &&
            chapterData
              .sort((a, b) => +a.order - +b.order)
              .map((chapter) => {
                return (
                  <ListEntryDesktop
                    key={chapter.id + 'desktop'}
                    target={chapter.el}
                    active={chapter.id === activeChapter}
                    long={chapter.title}
                    short={chapter.short}
                    colorMode={colorMode}
                    id={chapter.id}
                    trackEvent={trackEvent}
                  />
                )
              })}
        </ListContainerDesktop>
      )}
    </AppContainer>
  )
}

const ListEntryDesktop = ({
  target,
  active = false,
  long,
  short,
  colorMode,
  id,
  trackEvent,
}: {
  target: HTMLDivElement
  active: boolean
  long: string
  short: string
  colorMode: 'light' | 'dark' | undefined
  id: string
  trackEvent?: (label: string, eventData: { [key: string]: any }) => void
}) => {
  const [isHovered, setHovered] = useState(false)
  return (
    <>
      <StyledListEntryDesktop
        colorMode={colorMode}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => {
          trackEvent?.('Interactions' + id, {
            event_action: 'click',
            event_label: 'chapternav_desk_selected_' + id,
          })
          target && target.scrollIntoView({ behavior: 'smooth' })
        }}
        active={active}
        isHovered={isHovered}
      >
        <div className='content'>
          <div className='short'>{short || long}</div>
          <div
            className='long'
            dangerouslySetInnerHTML={{
              __html: long,
            }}
          ></div>
        </div>
      </StyledListEntryDesktop>
    </>
  )
}

const ListContainerDesktop = styled.div<{
  xpos: number
  colorMode: 'light' | 'dark' | undefined
  offsetX: number
}>`
  pointer-events: none;
  position: fixed;
  right: 0px;
  top: 30%;
  bottom: 0;
  direction: rtl;
  text-align: right;
  width: 300px;
  z-index: 900;
`

const StyledListEntryDesktop = styled.div<{
  active: boolean
  colorMode: 'light' | 'dark' | undefined
  isHovered: boolean
}>`
  pointer-events: all;
  user-select: none;
  font-size: 13px;
  font-weight: ${({ active }) => (active ? '700' : 'unset')};
  font-family: var(--font-sans-serif);
  line-height: 1.4em;
  /*  */

  color: #fff;
  background-color: ${({ active }) =>
    active ? 'var(--brandblue-main)' : 'var(--brandblue-bright-3)'};
  max-width: 160px;
  margin-bottom: 4px;
  padding-right: 12px;
  padding-left: 12px;
  transition: max-width 0.5s ease;
  /*  */
  max-height: 42px;
  height: 42px;
  overflow: hidden;
  /*  */
  border-right: ${({ isHovered, active }) =>
    isHovered || active
      ? '2px solid var(--brandblue-main)'
      : '2px solid var(--site-background)'};

  box-shadow: ${({ isHovered, active }) =>
    isHovered || active
      ? '4px solid var(--brandblue-main)'
      : '1px 0 0 0 var(--brandblue-bright-3)'};
  .content {
    max-height: 40px;
    pointer-events: none;
    position: relative;
    text-align: right;
    height: 100%;
    .short {
      white-space: nowrap;
      position: absolute;
      top: 0;
      display: flex;
      align-items: center;
      height: 100%;
      opacity: 1;
      direction: ltr;
    }
    .long {
      text-align: left;
      position: absolute;
      top: 0;
      left: 0;
      line-height: 1.2em;
      margin-top: 1px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 100%;
      min-width: 160px;
      opacity: 0;
      direction: ltr;

      img {
        position: absolute;
        right: -40px;
      }
    }
  }
  /*  */

  /*  */
  &:hover,
  *:hover {
    .content {
      text-align: left;
      min-width: 180px;
      .long {
        opacity: 1;
        min-width: 188px;
        max-width: 188px;
      }
      .short {
        opacity: 0;
      }
    }
    padding-right: 0;
    cursor: pointer;
    overflow: hidden;
    max-width: 220px;
    background-color: #202346;
    /* padding-right: 20px; */
  }
`

/*







*/

const ListEntry = ({
  id,
  target,
  active = false,
  long,
  short,
  colorMode,
  onSelect,
  trackEvent,
  hideShort = true,
}: {
  id: string
  target: HTMLDivElement
  active: boolean
  long: string
  short: string
  colorMode: 'light' | 'dark' | undefined
  onSelect: () => void
  trackEvent?: (label: string, eventData: { [key: string]: any }) => void
  hideShort?: boolean
}) => {
  const ref = useRef<HTMLButtonElement>()
  return (
    <StyledListEntry
      className='listEntry'
      id={id}
      ref={ref}
      onClick={() => {
        trackEvent?.('Interactions', {
          event_action: 'click',
          event_label: 'chapternav_mob_selected_' + id,
        })

        target && target.scrollIntoView({ behavior: 'smooth' })
        onSelect && onSelect()
      }}
      active={active}
    >
      <div>
        {short && !hideShort && <span>{short}</span>}
        <div
          dangerouslySetInnerHTML={{
            __html: long,
          }}
        ></div>
      </div>
    </StyledListEntry>
  )
}

const StyledListEntry = styled.button<{ active: boolean }>`
  height: 100%;
  line-height: 1.5em;
  flex: 0 0 38%;
  min-width: 38%;
  width: 38%;
  max-width: 200px;
  font-family: var(--font-sans-serif);
  padding: 15px;
  font-size: 15px;
  color: #fff;
  white-space: pre-wrap;
  scroll-snap-align: start;
  user-select: none;
  font-weight: ${({ active }) => (active ? '700' : 'unset')};
  background-color: #202346;
  border: 0;
  text-align: left;
  vertical-align: text-top;
  display: inline-block !important;
  div {
    pointer-events: none;
    display: inline-block !important;
    height: 200px;
  }
  span {
    display: inline-block;
    pointer-events: none;

    width: 100%;
    line-height: 2em;
    opacity: 0.8;
  }
`

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  z-index: 1000;
`
const MenuContainerMobile = styled.div<{ isOpen: boolean }>`
  position: fixed;
  display: flex;
  right: 0;
  bottom: 0;
  max-width: ${({ isOpen }) => (isOpen ? '100vw' : '0')};
  min-width: ${({ isOpen }) => (isOpen ? '100vw' : '0')};

  z-index: 1000;
  max-height: ${({ isOpen }) => (isOpen ? '200px' : '0px')};
  height: ${({ isOpen }) => (isOpen ? '200px' : '50px')};
  transition: all 0.25s ease;

  &:hover {
    .list {
      height: ${({ isOpen }) => (isOpen ? '200px' : '0')};
    }
  }
`
const ListContainer = styled.div<{
  isOpen: boolean
  colorMode: 'light' | 'dark' | undefined
}>`
  /* position: fixed; */
  overflow-x: scroll;
  overflow-y: hidden;
  right: 10px;
  transition: height 0.5s ease;
  top: 0;
  display: flex;
  flex-direction: row;
  scroll-snap-type: x mandatory;

  background-color: ${({ colorMode }) =>
    colorMode === 'dark'
      ? 'var(--brandblue-bright-1)'
      : 'var(--brandblue-main)'};
`
const MenuButton = styled.div<{
  isOpen: boolean
  colorMode: 'light' | 'dark' | undefined
}>`
  user-select: none;
  display: inline-block;
  height: 57px;
  overflow: hidden;
  background-color: ${({ colorMode }) =>
    colorMode === 'dark'
      ? 'var(--brandblue-bright-1)'
      : 'var(--brandblue-main)'};
  position: absolute;

  top: -57px;
  right: 0;
  width: 57px;
  transition: all 0.5s ease;
  transition-delay: 0.15s;
  img {
    max-width: 40px;
  }
  img.open {
    position: absolute;
    top: 8px;
    left: 8px;
    transition: all 0.5s ease;
    transition-delay: 0.1s;
    opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
  }
  img.close {
    position: absolute;

    top: 8px;
    left: 8px;
    transition: all 0.5s ease;
    opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-180deg)' : 'rotate(0deg)')};
  }
`
export default MainComponent
